import type { FontMetrics, TextStyle } from '../elements/flex_label.ts';
import type { TileFont } from '../tiles/value/value_tile.ts';

// The look of a tile, taken from the legacy MAUI app: Resources/Styles/Colors.xaml and the XAML
// of TileView. The page loads the font itself (the app's `index.css`).

/** The legacy app draws all tile text with Titillium Web (legacy/Skia/SkiaFlexLabel.cs). */
export const TILE_FONT_FAMILY = '"Titillium Web"';

/**
 * Cap height and descent of TitilliumWeb-Regular.ttf (OS/2 sCapHeight 692 and hhea descender 388
 * per 1000 units), the values Skia used. Taken from the file, not measured, because engines report
 * different descents for the same font (0.388 on Windows, 0.25 in Android WebView 124).
 */
export const TILE_FONT_METRICS: FontMetrics = { capHeight: 0.692, descent: 0.388 };

export const TILE_FONT: TileFont = { family: TILE_FONT_FAMILY, metrics: TILE_FONT_METRICS };

export const TILE_BACKGROUND = '#151515';

/** `LightYellow`. */
export const TITLE_COLOR = '#ffffe0';

export const TITLE_STYLE: TextStyle = {
    family: TILE_FONT_FAMILY,
    metrics: TILE_FONT_METRICS,
    fitWidth: true,
    align: 'center',
    valign: 'top',
};

/** Height of the title row of a tile, and the room the title text gets inside it. */
export const TITLE_ROW_HEIGHT = 26;
export const TITLE_TEXT_HEIGHT = 20;
export const TITLE_LEFT_MARGIN = 3;

export const TILE_PADDING = 5;
export const TILE_RADIUS = 4;
